// Historical flags are issued by the backend only for capabilities with a
// historical-read policy. Callers must still identify the operation as a read.
export function featureAccess(state, feature, intent = 'write') {
    if (!feature) return 'active';
    if (!state.hasLoaded) return 'loading';
    if (state.loadError) return 'error';
    if (state.features?.[feature] === true) return 'active';
    if (intent === 'read' && state.entitlements?.historicalFeatures?.[feature] === true) return 'historical';
    return 'denied';
}
export const canAccessFeature = (state, feature, intent = 'write') => ['active', 'historical'].includes(featureAccess(state, feature, intent));
